export default {
	name: 'click-outside',
	bind (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			if (!(el === event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event)
			}
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind (el) {
		if (document.getElementsByClassName('body-popup').length !== 0) {
			document.getElementsByClassName('body-popup').forEach((popup) => {
				popup.remove()
			})
		}
		document.body.removeEventListener('click', el.clickOutsideEvent)
	}
}
